export const EMAIL_REQUIRED = 'EMAIL_REQUIRED';
export const INVALID_EMAIL = 'Invalid email address';
export const ACCOUNT_EXISTS = 'ACCOUNT_EXISTS';
export const EmailPreferences = {
  ALWAYS: 'always',
  SOMETIMES: 'sometimes',
  NEVER: 'never',
};
